// extracted by mini-css-extract-plugin
export default {"l":"_01f359cdfa"};